import React from 'react';
import UniversalAddItemForm from '../shared/UniversalAddItemForm';

const AddItemToTransfertForm = ({ refTransfert, sourceEntrepot, onSuccess }) => {
  return (
    <UniversalAddItemForm
      refField="REF_TRF"
      refValue={refTransfert}
      onSuccess={onSuccess}
      codeEnt={sourceEntrepot}
      priceType="none"
      enableBatch={true}
      useArticleList={false}
      quantityFieldName="QTE_STK"
      submitButtonText="Add all to Transfert"
    />
  );
};

export default AddItemToTransfertForm;
